import { Card } from "./Card";
import { ensureElement } from "../../../utils/utils";
export class CardBasket extends Card {
    constructor(container, actions) {
        super(container, {});
        this._index = ensureElement('.basket__item-index', this.container);
        this._button = ensureElement('.basket__item-delete', this.container);
        if (actions === null || actions === void 0 ? void 0 : actions.onDeleteClick) {
            this._button.addEventListener('click', (e) => {
                var _a;
                e.stopPropagation();
                (_a = actions.onDeleteClick) === null || _a === void 0 ? void 0 : _a.call(actions, this.id);
            });
        }
    }
    set index(value) {
        this.setText(this._index, value);
    }
}
